import { Controller } from "@hotwired/stimulus"
import Swiper from 'swiper'
import { Pagination, Navigation, Autoplay, EffectCube, EffectCoverflow, EffectFlip, EffectCards, EffectFade, EffectCreative } from 'swiper/modules'

// Connects to data-controller="swiper"
export default class extends Controller {
  static values = {
    direction: String,
    autoplay: Number,
    effect: String,
    speed: Number,
  }

  connect() {
    const swiper = new Swiper(this.element, {
      loop: false,
      speed: this.speedValue || 3000,
      touchReleaseOnEdges: true,
      passiveListeners: true,
      // zoom: true,
      modules: [Pagination, Navigation, Autoplay, EffectCube, EffectCoverflow, EffectFlip, EffectCards, EffectFade, EffectCreative],
      autoHeight: false,
      slidesPerView: "auto",
      // spaceBetween: 10,
      lazy: true,

      navigation: false,
      direction: this.directionValue || 'horizontal',

      // autoplay: true,
      autoplay: {
        delay: this.autoplayValue || 3000,
        disableOnInteraction: true,
      },

      // If we need pagination
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },

      effect: this.effectValue || 'slide',
      grabCursor: true,
      centeredSlides: true,
      coverflowEffect: {
        rotate: 30,
        stretch: 0,
        depth: 200,
        modifier: 2,
        slideShadows: false,
      },
      cubeEffect: {
        shadow: true,
        slideShadows: false,
        shadowOffset: 50,
        shadowScale: 0.44,
      },
      // Navigation arrows
      // navigation: {
      //   nextEl: ".swiper-button-next",
      //   prevEl: ".swiper-button-prev"
      // },

      // And if we need scrollbar
      // scrollbar: {
      //   el: this.element.querySelector(".swiper-scrollbar")
      // },
    });

    if (swiper.slides.length <= 1) {
      swiper.allowTouchMove = false;
    }
  }
}
